/**
 * Admin AppBar sits above MUI Modal (z-index) so the navbar info icon stays
 * usable. Keep modals vertically centered; cap height so the gutters clear
 * the fixed AppBar and leave visible space, scrolling overflow inside the
 * paper instead of lowering navbar z-index.
 *
 * Only the top needs to clear the AppBar, so top/bottom gutters are kept
 * separate rather than equal — otherwise a tall modal wastes as much space
 * below as the navbar takes up above. The vertical center is shifted down by
 * half the gutter difference so a maxHeight modal lands exactly at
 * TOP_GUTTER_PX / BOTTOM_GUTTER_PX, while shorter modals still center.
 *
 * Top gutter ≈ AppBar (~56px) + visible gap under the bar.
 * `100%` is relative to the MUI Modal root (fixed fullscreen).
 */
export const MODAL_TOP_GUTTER_PX = 76
export const MODAL_BOTTOM_GUTTER_PX = 18

/** Spread into centered MUI Modal paper `sx` (or `style` objects). */
export const modalBelowNavbarSx = {
  position: 'absolute' as const,
  left: '50%',
  top: `calc(50% + ${(MODAL_TOP_GUTTER_PX - MODAL_BOTTOM_GUTTER_PX) / 2}px)`,
  transform: 'translate(-50%, -50%)',
  maxHeight: `calc(100% - ${MODAL_TOP_GUTTER_PX + MODAL_BOTTOM_GUTTER_PX}px)`,
  overflowY: 'auto' as const,
  boxSizing: 'border-box' as const,
} as const
